<template>

  <div class="nice-selectfield" :id="'multiselect-' + uniq">
    <button class="nice-select" type="button" @click="toggleMenu" ref="button">
      {{ visibleValue }}<span>▾</span>
    </button>
  </div>

</template>

<script>

  import i18n from "i18n"
  import overlayModel from "./overlayModel.js"
  import MultiSelectPicker from "./MultiSelectPicker.vue"

  var uniqCounter = 0
  var focusLostListener = null

  export default {
    name: 'multi-select',
    components: {
    },
    props: {
      options: {
        type: Array
      },
      value: {
        type: Array
      },
      allOption: {
        type: Boolean
      },
      without: {
        type: Boolean
      },
      many: {},
      display: {
        type: Function,
        default: (x)=>x.title || x
      }
    },
    data () {
      return {
        uniq: "" + (uniqCounter++),
        overlayStackId: null,
        lastCloseTime: 0
      }
    },
    computed: {
      visibleValue() {
        if(this.value.length == 0) return this.i18n().none
        if(this.allOption && this.value.length == this.options.length) return this.i18n().all
        if(this.without && this.value.length > (this.options.length/2 + 2))
          return this.i18n().without+" "+this.options.filter(
              option => this.value.indexOf(option) == -1
            ).map(v=>this.display(v)).join(', ')
        if(this.many && this.value.length > 1) {
          return ""+this.value.length +" / "+this.options.length+" "+this.many
        }
        return this.value.map(v=>this.display(v)).join(', ')
      }
    },
    watch: {
      value(q) {
        this.liveValue = q.slice()
      }
    },
    methods: {
      i18n() { return i18n().multiSelect },

      isSelected(option) {
        for(let other of this.value) {
          if(JSON.stringify(option) == JSON.stringify(other)) return true
        }
        return false
      },
      toggleMenu() {
        if(this.overlayStackId === null &&  Date.now() - this.lastCloseTime > 230) {
          this.overlayStackId = overlayModel.show({
            component: MultiSelectPicker,
            props: {
              anchor: overlayModel.elementAnchor(this.$refs.button),
              value: this.value,
              options: this.options,
              allOption: this.allOption,
              without: this.without,
              many: this.many,
              display: this.display
            },
            on: {
              'update:value': (value) => this.$emit('update:value', value),
              close: () => {
                this.overlayStackId = null
                this.lastCloseTime = Date.now()
              }
            }
          })
        } else {
          overlayModel.close(this.overlayStackId)
          this.overlayStackId = null
          this.lastCloseTime = Date.now()
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .nice-select {
    position: relative;
    border: none;
    border-bottom: 1px solid rgba(0,0,0,.12);
    display: block;
    font-size: 16px;
    font-family: "Helvetica","Arial",sans-serif;
    margin: 0;
    padding: 4px 0;
    width: 100%;
    background: 0 0;
    text-align: left;
    color: inherit;
    padding-right: 1.23em
  }

  .nice-select > span {
    display: block;
    position: absolute;
    right: 0;
    top: 10%;
    cursor: default;
  }

  .nice-selectfield {
    font-size: 16px;
    display: inline-block;
    box-sizing: border-box;
    width: 300px;
    max-width: 100%;
    margin: 0;
    padding: 10px 0;
  }

  .overlay {
    width: 50vw;
    pointer-events: none;
    display: flex;
    flex-direction: row;
  }

</style>



// WEBPACK FOOTER //
// MultiSelect.vue?7150d5c2